import { Injectable } from '@angular/core';

export interface Witness {
  nome: string;
  cognome: string;
  email: string;
  telefono: string;
  dichiarazione: string;
}

@Injectable({
  providedIn: 'root'
})
export class WitnessValidatorService {
  isEmailValid(email: string): boolean {
    if (!email) return true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  }

  isWitnessValid(witness: Witness): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return witness.nome.trim() !== '' && 
           witness.cognome.trim() !== '' && 
           witness.email.trim() !== '' && 
           emailRegex.test(witness.email.trim());
  }

  isWitnessEmpty(witness: Witness): boolean {
    return witness.nome.trim() === '' && 
           witness.cognome.trim() === '' && 
           witness.email.trim() === '' && 
           witness.telefono.trim() === '' && 
           witness.dichiarazione.trim() === '';
  }

  validateAllWitnesses(witnesses: Witness[], hasWitnesses: boolean): boolean {
    if (!hasWitnesses) {
      return true;
    }

    // Deve esserci almeno un testimone valido
    const hasValidWitness = witnesses.some(w => this.isWitnessValid(w));
    // Tutti i testimoni devono essere o vuoti o validi
    const allValidOrEmpty = witnesses.every(w => this.isWitnessEmpty(w) || this.isWitnessValid(w));
    return hasValidWitness && allValidOrEmpty;
  }
}